import { useHistory, useLocation } from 'react-router';
import { useCallback } from 'react';

import { PatientPresence } from '@dreryk/egabinet-appointment-frontend-api';

import { createInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';

import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys } from '../../../../../translations';

import { getPatientPresenceFilterCount, getPatientPresenceFilterSearchParamValue } from './PatientPresenceField.utils';
import { patientPresenceFilterStorage } from './PatientPresenceField.storage';

export const usePatientPresenceTriggerLabelExtractor = (): ((currentPatientPresences: PatientPresence[]) => string) => {
   const translate = useTranslate();

   return (currentPatientPresences) => {
      if (!currentPatientPresences.length) {
         return translate(appointmentsTranslationKeys.patientPresenceStatusFilter.selectPatientPresenceStatuses);
      }
      return translate(
         createInterpolatedTranslationKey(appointmentsTranslationKeys.patientPresenceStatusFilter.chosenOf, {
            count: currentPatientPresences.length,
            totalCount: getPatientPresenceFilterCount(),
         })
      );
   };
};

export const usePatientPresenceFilterSearchParamHandler = (
   currentPatientPresences: PatientPresence[]
): VoidFunction => {
   const history = useHistory();
   const location = useLocation();

   return useCallback(() => {
      const searchParams = new URLSearchParams(location.search);
      const patientPresenceFilterValue = getPatientPresenceFilterSearchParamValue(currentPatientPresences);

      if (currentPatientPresences.length) {
         searchParams.set(visitPaths.PATIENT_PRESENCE_SEARCH_PARAM, patientPresenceFilterValue);
         patientPresenceFilterStorage.setFilter(patientPresenceFilterValue);
      }

      if (!currentPatientPresences.length) {
         searchParams.delete(visitPaths.PATIENT_PRESENCE_SEARCH_PARAM);
         patientPresenceFilterStorage.deleteFilter();
      }

      return history.replace({ search: searchParams.toString(), state: location.state });
   }, [currentPatientPresences, history, location.search, location.state]);
};
